var map = {
	"./adfrac-fr.json": [
		93322,
		93322
	],
	"./adlang-idfpro.json": [
		76430,
		76430
	],
	"./adlatin-ai-fr.json": [
		27361,
		27361
	],
	"./admath-men.json": [
		399,
		399
	],
	"./admath-remediationseconde.json": [
		10341,
		10341
	],
	"./admath-specimen-remediation.json": [
		65043,
		65043
	],
	"./ar-SA.json": [
		82241,
		82241
	],
	"./athena-remediationseconde.json": [
		46415,
		46415
	],
	"./base.json": [
		74966,
		74966
	],
	"./en.json": [
		46594,
		46594
	],
	"./es.json": [
		88627,
		88627
	],
	"./fr.json": [
		57457,
		57457
	],
	"./it.json": [
		89963,
		89963
	],
	"./its-demo.json": [
		42332,
		42332
	],
	"./maspemaths-smc.json": [
		99992,
		99992
	],
	"./pt-pt.json": [
		97299,
		97299
	],
	"./pt_PT.json": [
		22794,
		22794
	],
	"./remediationseconde.json": [
		25240,
		25240
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 54181;
module.exports = webpackAsyncContext;